import { axios } from '@/api/common'
import { queryOptions } from '@tanstack/react-query'
import { Inv1010GetResultModel, Inv1010GetResultSchema } from './get.schema'

export async function fetchInv1010(id: number): Promise<Inv1010GetResultModel> {
  const response = await axios.get<Inv1010GetResultModel>(
    `/api/warehouse/inv1010/${id}`
  )
  return Inv1010GetResultSchema.parse(response.data)
}

export const getInv1010ByIdOptions = (id: number) =>
  queryOptions({
    queryKey: ['inv1010', id],
    queryFn: () => fetchInv1010(id),
  })
